import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import type { DateRange } from '@witmetrics/utils';
import { useReports } from '@/providers/ReportsProvider';
import { isTimeframeChanged } from '@/utils/time';
import DateRangeInput from '@/components/DateRangeInput';
import { classes } from './utils';

export type ReportHeaderProps = {
  showTimeframe?: boolean;
  className?: string;
  controlsClassName?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

export default function ReportHeader({
  showTimeframe = true,
  className,
  controlsClassName,
  title,
  subtitle,
  actions,
}: ReportHeaderProps) {
  const { timeframe, onUpdateTimeframe } = useReports();

  const handleUpdate = (update: DateRange) => {
    if (isTimeframeChanged(timeframe, update)) {
      onUpdateTimeframe(update);
    }
  };

  return (
    <div
      className={twMerge(
        classes.wrapper,
        (actions || showTimeframe) && classes.withActions,
        className
      )}>
      <div className={classes.titleBlock}>
        <h1 className={classes.title}>{title}</h1>
        {subtitle && <h4 className={classes.subtitle}>{subtitle}</h4>}
      </div>
      <div className={twMerge(classes.controls, controlsClassName)}>
        {actions || null}
        {showTimeframe && (
          <DateRangeInput
            disablePast={false}
            value={timeframe}
            name="timeframe"
            onApply={(update) => handleUpdate(update.timeframe)}
          />
        )}
      </div>
    </div>
  );
}
